import axios from "axios";
import { allowMethods } from "../../constants/appConstants";
import { generateIdempotencyKey, resolveRequestPath } from "../helper";
import { signRequest } from "../serviceHandler/csrfHandler";

const config = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY || "",
  },
};

export const backEndAPI = axios.create(config);

backEndAPI.interceptors.request.use(
  async (config) => {
    const method = (config.method ?? "").toLowerCase();
    const path = resolveRequestPath(config);
    const url = config.url ?? "";

    const idempotencyKey = generateIdempotencyKey();

    if (url.includes("/csrf")) return config;
    if (allowMethods.includes(method)) {
      const token = await signRequest(method, path)
      if (token && config.headers) {
        config.headers["X-CSRF-Token"] = token;
        if (method.toUpperCase() === "POST") {
          config.headers["Idempotency-Key"] = idempotencyKey;
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);
